import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ISFormLayoutComponent } from './is-form-layout.component';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '../shared.module';

const materialModules = [
    MatIconModule
];

@NgModule({
    declarations: [ISFormLayoutComponent],
    imports: [
        CommonModule,
        SharedModule,
        ...materialModules    
    ],
    exports: [ISFormLayoutComponent],
    providers: [],
})
export class ISFormLayoutModule {}